import { render, staticRenderFns } from "./AppIndexAndPrevalenceTable.vue?vue&type=template&id=3cd812bc&scoped=true&"
import script from "./AppIndexAndPrevalenceTable.vue?vue&type=script&lang=ts&"
export * from "./AppIndexAndPrevalenceTable.vue?vue&type=script&lang=ts&"
import style0 from "./AppIndexAndPrevalenceTable.vue?vue&type=style&index=0&id=3cd812bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd812bc",
  null
  
)

export default component.exports